module.exports = __webpack_public_path__ + "img/character_8.b123bffb.svg";